import { ApiService } from "../..";

export const createNotFindSample = (data: { rejected_content: string; rejected_image_url: string[] }, sampleId:string) => {
  return ApiService.baseAction(
    `rejected-sample/${sampleId}/create_not_find`,
    {
      data,
    },
    "post"
  );
};
